import toError from './parsers/error';

import * as http from '../../utils/http';

export default function (settings) {

  function get() {
    return http.get(`${settings.apiUrl}/catalog/users/stats`)
      .then(response => {
        const { tags = [], categories = [] } = response.data;
        return {
          tags: _.map(tags, 'value'),
          categories: _.map(categories, 'value'),
        };
      })
      .catch(toError);
  }

  return {
    get,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/autocomplete.js